import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const FranchiseFixedFeeAmountField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="franchiseFixedFeeAmountLabel"
			value={restaurantForFullInfo?.vivaWalletIsv?.franchiseCommission?.fixedAmount}
		/>
	);
};

export default FranchiseFixedFeeAmountField;
